const names = {};

names.TAGS = 'tags';

export default names;